import '@/assets/js/wmks/css/style.css';
import '@/assets/js/wmks/css/wmks-all.css';
import WMKS from '@/assets/js/wmks/wmks.min';
import '@/assets/scss/main.scss';
import { $http } from '@/plugins/common/http';
import GAuth from '@/plugins/google-auth';
import helpers from '@/plugins/helpers';
import i18n from '@/plugins/i18n';
import '@/plugins/live-chat';
import VueSentry from '@/plugins/sentry';
import metaConversionsApi from '@/plugins/meta-conversions-api';
import seoHelpers from '@/plugins/seo-helpers';
import VueGtm from '@gtm-support/vue2-gtm';
import { StripePlugin } from '@vue-stripe/vue-stripe';
import { BootstrapVue } from 'bootstrap-vue';
import 'boxicons/css/boxicons.min.css';
import moment from 'moment-timezone';
import 'sweetalert2/dist/sweetalert2.min.css';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import VueCookies from 'vue-cookies';
import InfiniteLoading from 'vue-infinite-loading';
import VueMoment from 'vue-moment';
import VueNativeNotification from 'vue-native-notification';
import LoadScript from 'vue-plugin-load-script';
import VueSocketIO from 'vue-socket.io';
import VueSweetalert2 from 'vue-sweetalert2';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import App from './App.vue';
import router from './router';
import store from './store';

const nodeEnv = process.env.NODE_ENV || 'development';

Vue.config.productionTip = false;
Vue.prototype.$http = $http;
Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);
Vue.use(VueMoment, {
    moment,
});
Vue.use(WMKS);
Vue.use(
    new VueSocketIO({
        connection: process.env.VUE_APP_API_URL,
        options: { transports: ['websocket'] },
    })
);
Vue.use(VueNativeNotification, {
    requestOnNotify: true,
});

Vue.use(PerfectScrollbar);

Vue.use(InfiniteLoading, {
    props: {
        spinner: 'default',
    },
    system: {
        throttleLimit: 50,
    },
    slots: {
        noMore: '',
    },
});

Vue.use(VueCookies);

if (process.env.VUE_APP_ENABLE_STRIPE_METHOD?.toLowerCase() === 'true') {
    Vue.use(StripePlugin, {
        pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
    });
}

Vue.use(VueClipboard);

if (process.env?.VUE_APP_GOOGLE_TAG_MANAGER_ID) {
    const gtmIds = process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID.split(',');
    Vue.use(VueGtm, {
        id: gtmIds,
        defer: false,
        enabled: true,
        debug: nodeEnv === 'development',
        loadScript: true,
        trackOnNextTick: false,
    });
}

Vue.use(VueSentry);

Vue.use(LoadScript);

Vue.use(GAuth);

Vue.prototype.$eventBus = new Vue();

const app = new Vue({
    router,
    i18n,
    store,
    render: (h) => h(App),
}).$mount('#app');

Vue.prototype.$helpers = helpers(app);
Vue.prototype.$metaConversionsApi = metaConversionsApi(app);
Vue.prototype.$seoHelpers = seoHelpers(app);
